<script setup>
const emit = defineEmits(['request']);
</script>

<template>
    <div class="access-blocked">
        <p class="access-blocked__text">
            You do not currently have access to this Hub. If you believe you should have access, please
            <a href="#" class="access-blocked__link" @click.prevent="emit('request')">submit an access request</a>.
        </p>
    </div>
</template>

<style scoped>
.access-blocked {
    background: #FFDAD6;
    border-radius: 8px;
    padding: 16px 20px;
}
.access-blocked__text {
    color: #690005;
    font-size: 14px;
    line-height: 1.6;
    margin: 0;
    text-align: left;
}
.access-blocked__link {
    color: #BA1A1A;
    font-weight: 700;
    text-decoration: underline;
    cursor: pointer;
}
</style>
